import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';
import PropertyKeyContact from './PropertyKeyContact';

function PropertyKeyContacts(props) {
  // Data
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [users, setUsers] = useState([]);
  const [loadingPropertyKeyContacts, setLoadingPropertyKeyContacts] = useState(
    false
  );
  const [propertyKeyContacts, setPropertyKeyContacts] = useState([]);

  /**
   * Load all property key contacts and users when the bearer token prop is updated.
   */
  useEffect(() => {
    // Load users
    setLoadingUsers(true);
    fetch(`${process.env.REACT_APP_AUTH_API_URL}api/users`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + props.bearerToken,
        service: 'fruition'
      }
    })
      .then((res) => {
        if (res.ok) return res.json();
        else if (res.status === 401) props.refreshBearerToken();
        else throw Error(res.statusText);
      })
      .then((data) => {
        if (data) {
          setUsers(data);
        }
      })
      .catch((err) => {
        if (process.env.NODE_ENV === 'development') console.error(err);
        setUsers([]);
      })
      .finally(() => {
        setLoadingUsers(false);
      });

    // Load property key contacts
    setLoadingPropertyKeyContacts(true);
    fetch(
      `${process.env.REACT_APP_PROPERTIES_API_URL}api/property-key-contacts`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.bearerToken,
          SeasonalDatabase: props.selectedDatabase
        }
      }
    )
      .then((res) => {
        if (res.ok) return res.json();
        else if (res.status === 401) props.refreshBearerToken();
        else throw Error(res.statusText);
      })
      .then((data) => {
        if (data) {
          setPropertyKeyContacts(data);
        }
      })
      .catch((err) => {
        if (process.env.NODE_ENV === 'development') console.error(err);
        setPropertyKeyContacts([]);
      })
      .finally(() => {
        setLoadingPropertyKeyContacts(false);
      });
  }, [props.bearerToken]);

  const updatePropertyKeyContact = (propertyKeyContact) => {
    const index = propertyKeyContacts.findIndex(
      (p) => p.id === propertyKeyContact.id
    );
    if (index > -1) {
      const newPropertyKeyContacts = [...propertyKeyContacts];
      newPropertyKeyContacts[index] = propertyKeyContact;
      setPropertyKeyContacts(newPropertyKeyContacts);
    }
    props.updatePropertyKeyContact(propertyKeyContact);
  };

  // Check if anything is loading
  if (loadingUsers || loadingPropertyKeyContacts) {
    return <Spinner animation='border' variant='primary' />;
  } else {
    const selectedPropertyKeyContact =
      propertyKeyContacts[
        propertyKeyContacts.findIndex(
          (element) => element.id === props.selectedPropertyKeyContactId
        )
      ];

    // Check if a valid property has been selected
    if (selectedPropertyKeyContact) {
      return (
        <PropertyKeyContact
          propertyKeyContact={selectedPropertyKeyContact}
          users={users}
          update={updatePropertyKeyContact}
          close={() => props.changeSelectedPropertyKeyContact(null)}
          {...props}
        />
      );
    } else {
      return null;
    }
  }
}

PropertyKeyContacts.propTypes = {
  bearerToken: PropTypes.string.isRequired,
  refreshBearerToken: PropTypes.func.isRequired,
  selectedDatabase: PropTypes.string.isRequired,
  selectedPropertyKeyContactId: PropTypes.number.isRequired,
  changeSelectedPropertyKeyContact: PropTypes.func.isRequired
};

export default PropertyKeyContacts;
